// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__nmisH","col":"styles_col__1JVTU"};